module.exports = __webpack_public_path__ + "static/media/img-heritage-area2-SekiyoshiSluiceGate.490cbfb2.jpg";